'use client';

import { HoverPrefetchLink } from '@/components/ui/hover-prefetch-link';
import { usePathname } from 'next/navigation';
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar
} from '@/components/ui/sidebar';
import { IconMapper } from '@/components/ui/icon-mapper';

export function NavSecondary({
  items,
  className
}: {
  items: {
    title: string;
    url: string;
    icon?: string;
  }[];
  className?: string;
}) {
  const pathname = usePathname();
  const { setOpenMobile, isMobile } = useSidebar();

  // Ensure items is always an array
  const safeItems = items || [];

  const handleLinkClick = () => {
    // Close mobile sidebar when a link is clicked
    if (isMobile) {
      setOpenMobile(false);
    }
  };

  return (
    <SidebarGroup className={className}>
      <SidebarGroupContent>
        <SidebarMenu>
          {safeItems.map((item) => (
            <SidebarMenuItem key={item.title}>
              <SidebarMenuButton
                asChild
                size="sm"
                isActive={pathname === item.url}
              >
                <HoverPrefetchLink href={item.url} onClick={handleLinkClick}>
                  {item.icon && <IconMapper iconName={item.icon} />}
                  <span>{item.title}</span>
                </HoverPrefetchLink>
              </SidebarMenuButton>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
